import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  FormControl,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { Control, Controller, UseFormRegister } from 'react-hook-form';
import { AvailableFiltersSchema, SavedFilterResults } from '@/zod_schemas';

interface FilterTypeProps {
  type: string;
  control: Control<SavedFilterResults>;
  register: UseFormRegister<SavedFilterResults>;
  availableFilters: AvailableFiltersSchema;
  typographyText: string;
}

const FilterType = ({
  type,
  control,
  register,
  availableFilters,
  typographyText,
}: FilterTypeProps) => (
  <Accordion>
    <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
      <Typography>{typographyText}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          borderRadius: 3,
          backgroundColor: 'background.default',
          minWidth: 300,
        }}
      >
        <Typography variant="body1" fontWeight={600} mb={1}>
          Parameter
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Stack spacing={2}>
          {type === 'vcf_filters' &&
            availableFilters.vcf_filters.map((filter) => (
              <FormControl key={filter.name} fullWidth>
                <Controller
                  name={`request_filters.filters.vcf_filters.${filter.name}`}
                  control={control}
                  defaultValue="" // Ensure default value
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label={filter.name}
                      fullWidth
                      size="small"
                      variant="outlined"
                      {...register(
                        `request_filters.filters.vcf_filters.${filter.name}`,
                      )}
                    />
                  )}
                />
              </FormControl>
            ))}

          {type === 'annotation_filters' &&
            availableFilters.annotation_filters.map((filter) => (
              <FormControl key={filter.name} fullWidth>
                <Controller
                  name={`request_filters.filters.annotation_filters.${filter.name}`}
                  control={control}
                  defaultValue="" // Ensure default value
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label={filter.name}
                      fullWidth
                      size="small"
                      variant="outlined"
                      {...register(
                        `request_filters.filters.annotation_filters.${filter.name}`,
                      )}
                    />
                  )}
                />
              </FormControl>
            ))}
        </Stack>
      </Paper>
    </AccordionDetails>
  </Accordion>
);

export default FilterType;
